import { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import {
  getToastOptions,
  showErrorToast,
  showSuccessToast,
  showToast
} from '../services/toastService';
import { TOAST_MESSAGE_TYPES } from '@shared/constants/toastMessageTypes';

export function useLoadingToast(message) {
  const toastIdRef = useRef(null);
  useEffect(() => {
    return () => {
      if (toastIdRef.current) {
        toast.dismiss(toastIdRef.current);
        clearToastRef(toastIdRef);
      }
    };
  }, [toastIdRef]);

  const show = () => {
    toastIdRef.current = showToast(TOAST_MESSAGE_TYPES.LOADING, message, null, true, true);
  };

  const updateToSucess = sucessMessage => {
    if (toastIdRef.current) {
      const options = getToastOptions(TOAST_MESSAGE_TYPES.SUCCESS, toastIdRef.current, true, false);
      toast.update(toastIdRef.current, { render: sucessMessage, ...options });
      clearToastRef(toastIdRef);
      return;
    }
    showSuccessToast(sucessMessage);
  };

  const updateToError = errorMessage => {
    if (toastIdRef.current) {
      const options = getToastOptions(TOAST_MESSAGE_TYPES.ERROR, toastIdRef.current, true, false);
      toast.update(toastIdRef.current, { render: errorMessage, ...options });
      clearToastRef(toastIdRef);
      return;
    }
    showErrorToast(errorMessage);
  };

  return { show, updateToSucess, updateToError };
}

function clearToastRef(ref) {
  ref.current = null;
}
